import { FlightingService } from "../sdServices/flightingSvc";

// @ngInject
export function isFlightActiveFilter(flightingService: FlightingService) {
  return function (input: string) {
    return flightingService.isFlightEnabled(input);
  };
}
